import React from 'react';

// This is a minimal React wrapper for the static Mario portfolio site
// The actual content and functionality is in the public/index.html file
function App() {
  return null;
}

export default App;